module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAQAAAD8x0bcAAABOElEQVQoz5XSzyvkYRwH8M/aloxfxYGmlFqJHBzFwclhtbVRSq3WZJBcHMYeNgcnpYxN25ac5GrbE+flICVlf9hG7g7yV7z28F3fGXHgeZ/eT6+enl8RzxtaLDnyS8mZj5ofI00+++OTQW98dWlD00M07txbLyIivDTqp3cP0ZZvGtLW6Lsv90G9Nh8Ma6vIsCmtau9Iux0lV/66TFNy4cq5VS0JmvbbjJycabPmzJmVNy9nxqnRBOX9kNFhXle6gQErumUcyicTQ451KmDdq4gINbax7LVjQwnqtW9Ej6IBVRERqvQr6jFiX2+CsnYtRKi7d+K6CAt2ZZOasWnt0YdasylzVwr20hspk1p7CuU65uD/spUo68BYufY5UTThvck0E4pO9JVRtUXXbtxW5Ma1RdVP/mn/AEfa9P/oQG/8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/lsNavIcon/lsouIcon.png
// module id = gjiN
// module chunks = 95